module.exports = __webpack_public_path__ + "static/media/triangle.09d90b67.svg";